/* Nancy's Tanks — custom section behaviour (countdown, bundle builder, size finder, sticky CTA, gallery).
   Re-initialises per section so it works in the theme editor (shopify:section:load) as well as on the storefront. */
(function () {
  'use strict';
  if (window.__ntLoaded) return; window.__ntLoaded = true;

  function isInView(el) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  function money(cents) {
    var fmt = window.ntMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (fmt.indexOf('amount_no_decimals') > -1) amount = Math.round(cents / 100).toString();
    else if (fmt.indexOf('amount_with_comma_separator') > -1) amount = amount.replace('.', ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }
  function uniq(a) { return a.filter(function (x, i) { return x && a.indexOf(x) === i; }); }

  function initCountdown(el) {
    if (el.__nt) return; el.__nt = true;
    var end = Date.parse(el.getAttribute('data-nt-countdown'));
    if (isNaN(end)) return;
    var out = el.querySelector('[data-nt-countdown-out]');
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.hidden = true; return; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4);
      out.textContent = (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm';
    }
    tick(); setInterval(tick, 30000);
  }

  function updateSticky() {
    var sticky = document.querySelector('[data-nt-sticky]');
    var buyBox = document.querySelector('[data-nt-bundle]');
    if (!sticky || !buyBox) return;
    var hero = document.querySelector('[data-nt-hero]');
    var heroPassed = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
    sticky.classList.toggle('is-visible', heroPassed && !isInView(buyBox));
  }
  window.addEventListener('scroll', updateSticky, { passive: true });

  function initGallery(g) {
    if (g.__nt) return; g.__nt = true;
    var main = g.querySelector('[data-nt-gallery-main]');
    if (!main) return;
    g.querySelectorAll('[data-nt-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('[data-nt-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        main.src = t.getAttribute('data-src');
        main.removeAttribute('srcset');
        var im = t.querySelector('img'); main.alt = im ? im.alt : '';
      });
    });
  }

  function initBundle(root) {
    if (root.__nt) return; root.__nt = true;
    var product, tiers;
    try {
      product = JSON.parse(root.querySelector('[data-nt-product-json]').textContent);
      tiers = JSON.parse(root.querySelector('[data-nt-tiers-json]').textContent);
    } catch (e) { if (window.console) console.error('[nt] bundle JSON', e); return; }
    var colorMap = {};
    try { colorMap = JSON.parse(root.getAttribute('data-color-map') || '{}'); } catch (e) { colorMap = {}; }
    var colorIdx = product.options.indexOf(root.getAttribute('data-color-option'));
    var sizeIdx = product.options.indexOf(root.getAttribute('data-size-option'));
    if (colorIdx < 0) colorIdx = 0; if (sizeIdx < 0) sizeIdx = 1;
    var colors = uniq(product.variants.map(function (v) { return v.options[colorIdx]; }));
    var sizes = uniq(product.variants.map(function (v) { return v.options[sizeIdx]; }));
    function sized(src, w) { if (!src) return ''; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function imageFor(color) {
      for (var i = 0; i < product.variants.length; i++) { var v = product.variants[i]; if (v.options[colorIdx] === color && v.featured_image && v.featured_image.src) return v.featured_image.src; }
      return '';
    }
    root.querySelectorAll('[data-nt-swatch]').forEach(function (sw) {
      var name = sw.getAttribute('data-nt-swatch'); var img = imageFor(name); var c = colorMap[name];
      if (img) sw.style.backgroundImage = 'url(' + sized(img, 120) + ')'; else if (c) sw.style.background = c;
    });
    var fitNotes = {};
    (root.getAttribute('data-fit-notes') || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('|').map(function (x) { return x.trim(); }); if (p.length < 3 || !p[0]) return;
      fitNotes[p[0].toLowerCase() + '|' + p[1].toLowerCase()] = { color: p[0], size: p[1], rec: p[2] };
    });
    var fitText = root.getAttribute('data-fit-note-text') || '{color} fits a bit small in {size}.|We recommend {rec} in {color}.';
    function fitNote(color, size) {
      var n = fitNotes[(color || '').toLowerCase() + '|' + (size || '').toLowerCase()]; if (!n) return null;
      var t = fitText.replace(/\{color\}/g, n.color).replace(/\{size\}/g, n.size).replace(/\{rec\}/g, n.rec).split('|');
      return { strong: t[0], rest: t.slice(1).join(' ') };
    }
    function showColor(color) {
      var main = root.querySelector('[data-nt-gallery-main]'); var img = imageFor(color);
      if (main && img) { main.src = sized(img, 1200); main.removeAttribute('srcset'); main.alt = 'Nancy\'s Tank in ' + color; root.querySelectorAll('[data-nt-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); }); }
      root.querySelectorAll('[data-nt-swatch-btn]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-nt-swatch-btn') === color ? 'true' : 'false'); });
    }
    var rowsEl = root.querySelector('[data-nt-rows]');
    var tierEls = root.querySelectorAll('[data-nt-tier]');
    var btn = root.querySelector('[data-nt-add]');
    var btnTotal = root.querySelector('[data-nt-total]');
    var msg = root.querySelector('[data-nt-msg]');
    var state = { tier: 0, rows: [], colorPicked: false };
    for (var i = 0; i < 5; i++) state.rows.push({ color: colors[0], size: '' });
    // Ad / Google Shopping links carry ?variant= : start every row on that colour and size
    var initId = parseInt(root.getAttribute('data-initial-variant'), 10);
    if (initId) {
      var iv = product.variants.filter(function (v) { return v.id === initId; })[0];
      if (iv) { state.colorPicked = true; state.rows.forEach(function (r) { r.color = iv.options[colorIdx]; r.size = iv.available ? iv.options[sizeIdx] : ''; }); }
    }

    tierEls.forEach(function (el, i) {
      if (el.getAttribute('aria-checked') === 'true') state.tier = i;
      el.addEventListener('click', function () { state.tier = i; render(); });
    });

    function variantFor(color, size) {
      return product.variants.filter(function (v) { return v.options[colorIdx] === color && v.options[sizeIdx] === size; })[0];
    }
    function availableSizes(color) {
      return sizes.map(function (s) { var v = variantFor(color, s); return { size: s, ok: !!(v && v.available) }; });
    }
    function clearMsg() { msg.textContent = ''; msg.className = 'nt-buy__msg'; }
    function setMsg(text, kind) { msg.textContent = text; msg.className = 'nt-buy__msg nt-buy__msg--' + kind; }

    function render() {
      var tier = tiers[state.tier];
      tierEls.forEach(function (el, i) { el.setAttribute('aria-checked', i === state.tier ? 'true' : 'false'); });
      rowsEl.innerHTML = '';
      for (var i = 0; i < tier.qty; i++) {
        (function (idx) {
          var row = state.rows[idx];
          var wrap = document.createElement('div'); wrap.className = 'nt-row';
          var thumbSrc = imageFor(row.color);
          wrap.innerHTML =
            '<span class="nt-row__n">Tank ' + (idx + 1) + '</span>' +
            '<span class="nt-row__thumb" aria-hidden="true">' + (thumbSrc ? '<img src="' + sized(thumbSrc, 120) + '" alt="' + String(row.color).replace(/"/g, '&quot;') + ' tank" width="48" height="48" loading="lazy">' : '') + '</span>' +
            '<label class="nt-visually-hidden" for="nt-color-' + idx + '">Color for tank ' + (idx + 1) + '</label>' +
            '<select class="nt-select" id="nt-color-' + idx + '"></select>' +
            '<label class="nt-visually-hidden" for="nt-size-' + idx + '">Size for tank ' + (idx + 1) + '</label>' +
            '<select class="nt-select nt-select--size" id="nt-size-' + idx + '"></select>' +
            '<div class="nt-row__note" data-nt-row-note hidden></div>';
          var cSel = wrap.querySelector('#nt-color-' + idx), sSel = wrap.querySelector('#nt-size-' + idx), noteEl = wrap.querySelector('[data-nt-row-note]');
          var fn = fitNote(row.color, row.size);
          if (fn) { noteEl.innerHTML = '<b></b><span></span>'; noteEl.querySelector('b').textContent = fn.strong; noteEl.querySelector('span').textContent = fn.rest; noteEl.hidden = false; }
          colors.forEach(function (c) {
            var o = document.createElement('option'); o.value = c; o.textContent = c; if (c === row.color) o.selected = true; cSel.appendChild(o);
          });
          var o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'Size'; sSel.appendChild(o0);
          availableSizes(row.color).forEach(function (s) {
            var o = document.createElement('option'); o.value = s.size; o.textContent = s.ok ? s.size : s.size + ' (sold out)'; o.disabled = !s.ok; if (s.size === row.size && s.ok) o.selected = true; sSel.appendChild(o);
          });
          cSel.addEventListener('change', function () { row.color = cSel.value; state.colorPicked = true; var ok = availableSizes(row.color).filter(function (s) { return s.size === row.size && s.ok; }).length; if (!ok) row.size = ''; render(); });
          sSel.addEventListener('change', function () { row.size = sSel.value; clearMsg(); render(); });
          rowsEl.appendChild(wrap);
        })(i);
      }
      var fillEl = root.querySelector('[data-nt-tank-fill]'); var capEl = root.querySelector('[data-nt-color-name]');
      if (fillEl && colorMap[state.rows[0].color]) fillEl.setAttribute('fill', colorMap[state.rows[0].color]);
      if (capEl) capEl.textContent = state.rows[0].color;
      // Keep the lifestyle photo first; only switch to the colour photo once she picks a colour
      if (state.colorPicked) showColor(state.rows[0].color);
      btnTotal.textContent = money(tier.price);
      var stickyTotal = document.querySelector('[data-nt-sticky-total]');
      if (stickyTotal) stickyTotal.textContent = money(tier.price) + ' · ' + tier.label;
      clearMsg();
    }

    root.querySelectorAll('[data-nt-swatch-btn]').forEach(function (b) {
      b.addEventListener('click', function () { var c = b.getAttribute('data-nt-swatch-btn'); state.colorPicked = true; state.rows.forEach(function (r) { r.color = c; if (!availableSizes(c).filter(function (s) { return s.size === r.size && s.ok; }).length) r.size = ''; }); render(); });
    });
    root.querySelectorAll('[data-nt-apply-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.getAttribute('data-size'); if (!s) return;
        state.rows.forEach(function (r) { r.size = s; });
        render();
      });
    });

    btn.addEventListener('click', function () {
      var tier = tiers[state.tier];
      var items = [];
      for (var i = 0; i < tier.qty; i++) {
        var r = state.rows[i];
        if (!r.size) { setMsg('Choose a size for every tank first.', 'err'); return; }
        var v = variantFor(r.color, r.size);
        if (!v || !v.available) { setMsg('Tank ' + (i + 1) + ' is sold out in that color and size.', 'err'); return; }
        items.push({ id: v.id, quantity: 1, properties: { _bundle: tier.label } });
      }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      var cartDrawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (cartDrawer) body.sections = 'cart-drawer,cart-icon-bubble';
      var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      fetch(rootPath + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.disabled = false; btn.removeAttribute('aria-busy');
        if (res.status) { setMsg(res.description || res.message || 'Something went wrong.', 'err'); return; }
        setMsg('Added ' + tier.qty + (tier.qty === 1 ? ' tank' : ' tanks') + ' to your cart.', 'ok');
        if (cartDrawer && res.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          var inner = cartDrawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          cartDrawer.renderContents(res);
        } else {
          window.location.href = rootPath + 'cart';
        }
      }).catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); setMsg('Could not add to cart. Please try again.', 'err'); });
    });

    render();
  }

  function initSizeFinder(sf) {
    if (sf.__nt) return; sf.__nt = true;
    var chart;
    try { chart = JSON.parse(sf.getAttribute('data-chart')); } catch (e) { return; }
    var bustIn = sf.querySelector('[data-nt-sf-bust]') || sf.querySelector('input');
    var heightIn = sf.querySelector('[data-nt-sf-height]');
    var weightIn = sf.querySelector('[data-nt-sf-weight]');
    var go = sf.querySelector('[data-nt-sf-go]');
    var result = sf.querySelector('[data-nt-size-result]');
    var sizeOut = sf.querySelector('[data-nt-sf-size]') || (result && result.querySelector('span'));
    var warn = sf.querySelector('[data-nt-size-warn]');
    var apply = sf.querySelector('[data-nt-apply-size]');
    var howBtn = sf.querySelector('[data-nt-sf-howto]'), howPanel = sf.querySelector('[data-nt-sf-howto-panel]');
    if (howBtn && howPanel) howBtn.addEventListener('click', function () {
      var open = howPanel.hidden; howPanel.hidden = !open; howBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      howBtn.textContent = open ? 'Hide how to measure' : 'See how to measure your full bust';
    });
    function parseBust() {
      var raw = (bustIn && bustIn.value || '').toLowerCase().trim(); if (!raw) return NaN;
      var n = parseFloat(raw.replace(',', '.')); if (isNaN(n)) return NaN;
      if (raw.indexOf('cm') > -1 || n > 70) n = n / 2.54;
      return n;
    }
    function fromChart(inches) { var rec = null; chart.forEach(function (c) { if (inches >= c[1] && inches < c[2]) rec = c[0]; }); if (!rec && inches >= chart[chart.length - 1][2]) rec = chart[chart.length - 1][0]; return rec; }
    function estimate(h, w) {
      if (!w) return null;
      var bmi = h ? (w / (h * h)) * 703 : w / 4.2;
      var idx = bmi < 21 ? 0 : bmi < 24 ? 1 : bmi < 27 ? 2 : bmi < 30 ? 3 : bmi < 34 ? 4 : bmi < 38 ? 5 : 6;
      if (!h) { idx = w < 130 ? 0 : w < 150 ? 1 : w < 170 ? 2 : w < 190 ? 3 : w < 215 ? 4 : w < 240 ? 5 : 6; }
      return chart[Math.min(idx, chart.length - 1)][0];
    }
    function show(rec) {
      if (rec) {
        result.hidden = false; if (sizeOut) sizeOut.textContent = rec; warn.hidden = true;
        if (apply) { apply.hidden = false; apply.setAttribute('data-size', rec); if (!apply.hasAttribute('data-nt-sf-keep')) apply.textContent = 'Use ' + rec + ' for all tanks'; }
      } else { result.hidden = true; if (apply) apply.hidden = true; warn.hidden = false; }
    }
    function calc() {
      var b = parseBust();
      if (!isNaN(b) && b > 20) return show(fromChart(b));
      var h = heightIn ? parseFloat(heightIn.value) : NaN, w = weightIn ? parseFloat(weightIn.value) : NaN;
      if (!isNaN(w) && w > 50) return show(estimate(isNaN(h) ? 0 : h, w));
      show(null);
    }
    if (go) { go.addEventListener('click', calc); [bustIn, weightIn].forEach(function (el) { if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calc(); } }); }); }
    else if (bustIn) bustIn.addEventListener('input', calc);
  }

  // One-tap bundle upsell inside the cart drawer (works after every drawer re-render via delegation)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nt-cart-add]'); if (!b) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-nt-cart-add'), 10), qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
    if (!id) return;
    b.setAttribute('aria-busy', 'true'); var label = b.textContent; b.textContent = 'Adding…';
    var cartDrawer = document.querySelector('cart-drawer');
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var body = { items: [{ id: id, quantity: qty }] };
    if (cartDrawer) body.sections = 'cart-drawer,cart-icon-bubble';
    fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { b.removeAttribute('aria-busy'); b.textContent = label; return; }
        if (cartDrawer && res.sections && typeof cartDrawer.renderContents === 'function') { cartDrawer.renderContents(res); }
        else { window.location.href = rootPath + 'cart'; }
      })
      .catch(function () { b.removeAttribute('aria-busy'); b.textContent = label; });
  });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-nt-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-nt-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-nt-bundle]').forEach(initBundle);
    scope.querySelectorAll('[data-nt-sizefinder]').forEach(initSizeFinder);
    updateSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
